var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack208({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.58,7.89a1.93,1.93,0,0,1-.92-.74,1.9,1.9,0,0,1-.29-1A2.08,2.08,0,0,1,6,4.52a2.7,2.7,0,0,1,1.9-.62,2.76,2.76,0,0,1,1.91.62,2.08,2.08,0,0,1,.67,1.59,1.89,1.89,0,0,1-.31,1.07,2,2,0,0,1-.87.71,2.28,2.28,0,0,1,1.09.84A2.26,2.26,0,0,1,10.8,10,2.61,2.61,0,0,1,10,11.93a2.75,2.75,0,0,1-2,.74,3,3,0,0,1-1.95-.61,2.42,2.42,0,0,1-.92-2A2.37,2.37,0,0,1,5.5,8.79,2.21,2.21,0,0,1,6.58,7.89Zm.19,2A1.52,1.52,0,0,0,7.12,11a1.14,1.14,0,0,0,.87.38A1.07,1.07,0,0,0,8.83,11a1.46,1.46,0,0,0,.34-1.05,1.34,1.34,0,0,0-.34-1A1.11,1.11,0,0,0,8,8.59a1,1,0,0,0-.9.42A1.48,1.48,0,0,0,6.77,9.91Zm.15-3.68A1.07,1.07,0,0,0,7.2,7a1,1,0,0,0,.74.27A1,1,0,0,0,8.69,7,1,1,0,0,0,9,6.22a1,1,0,1,0-2.06,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack208);
export default __webpack_public_path__ + "static/media/Symbolpack_2_08.5660866308bff36f7bdb72ca3b9c0051.svg";
export { ForwardRef as ReactComponent };